import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { MMDRead, MMDReads } from '../../../../models/mmd-read';
import {
  MarketDrawerRootReducerState,
  getMMDDataState,
  getMMDLoadingState,
  getMMDUnseenState
} from '../../../../state/reducer';

@Component({
  selector: 'muni-gameday-market-drawer-mmd-header',
  templateUrl: './mmd-header.template.html',
  styleUrls: ['./mmd-header.styles.scss'],
  standalone: false,
})
export class MMDHeaderComponent {
  public readonly data: Observable<MMDReads> = this.store.pipe(
    select(getMMDDataState),
    distinctUntilChanged()
  );
  public readonly timeOfDay: Observable<string> = this.data.pipe(
    map((reads: MMDReads) => reads.timeOfDay)
  );
  public readonly reads: Observable<MMDRead[]> = this.data.pipe(
    map((reads: MMDReads) => reads.reads)
  );
  public readonly loading: Observable<boolean> = this.store.pipe(
    select(getMMDLoadingState),
    distinctUntilChanged()
  );
  public readonly unseen: Observable<boolean> = this.store.pipe(
    select(getMMDUnseenState),
    distinctUntilChanged()
  );
  public readonly readType: Observable<string> = this.data.pipe(
    map((reads: MMDReads) => reads.readType)
  );

  constructor(private store: Store<MarketDrawerRootReducerState>) {}
}
